// extracted by mini-css-extract-plugin
export default {"mainContent":"Politics_mainContent__yvcPI"};